// import React, { useEffect, useState } from "react";
// import { Tabs, Tab, Box, IconButton } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import { useApiContext } from "../../../Utils/ApiContext/ApiContext";
// import Loader from "../../../Container/Loader/Loader";
// import PatientDetails from "./PatientDetails";
// import PatientList from "./PatientList";
// import CryptoJS from "crypto-js";

// const STORAGE_KEY = "patientTabsData";
// const SECRET_KEY = process.env.REACT_APP_USER_ENC_DEC_KEY; 

// const PatientTabs = () => {
//   const { patients, loading, fetchData } = useApiContext();
//   const [patientTabs, setPatientTabs] = useState([]);
//   const [selectedTab, setSelectedTab] = useState(0);

//   useEffect(()=>{
//     fetchData('/apis/default/api/patient')
//   })

//   // Function to encrypt data
//   const encryptData = (data) => {
//     return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
//   };

//   // Function to decrypt data
//   const decryptData = (encryptedData) => {
//     try {
//       const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
//       return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//     } catch (error) {
//       console.error("Error decrypting data:", error);
//       return null;
//     }
//   };

//   // Load encrypted tabs from sessionStorage
//   useEffect(() => {
//     const storedData = sessionStorage.getItem(STORAGE_KEY);
//     if (storedData) {
//       const decryptedData = decryptData(storedData);
//       if (decryptedData && decryptedData.tabs.length > 0) {
//         setPatientTabs(decryptedData.tabs);
//         setSelectedTab(decryptedData.lastTab >= 0 ? decryptedData.lastTab : 0);
//       }
//     }
//     fetchData();
//   }, []);

//   // Store tabs in encrypted format in sessionStorage
//   useEffect(() => {
//     const encryptedTabs = encryptData({ tabs: patientTabs, lastTab: selectedTab });
//     sessionStorage.setItem(STORAGE_KEY, encryptedTabs);
//   }, [patientTabs, selectedTab]);

//   const handleOpenTab = (patient) => {
//     const existingIndex = patientTabs.findIndex((tab) => tab.pid === patient.pid);
//     if (existingIndex === -1) {
//       const newTab = {
//         pid: patient.pid,
//         uuid: patient.uuid,
//         name: `${patient.fname} ${patient.lname}`,
//         email: patient.email,
//         wallet_id: patient.wallet_id,
//       };
//       const updatedTabs = [...patientTabs, newTab];
//       setPatientTabs(updatedTabs);
//       setSelectedTab(updatedTabs.length);
//     } else {
//       setSelectedTab(existingIndex + 1);
//     }
//   };

//   const handleCloseTab = (index) => {
//     const updatedTabs = patientTabs.filter((_, i) => i !== index);
//     setPatientTabs(updatedTabs);
//     setSelectedTab(updatedTabs.length === 0 ? 0 : Math.max(0, selectedTab - 1));
//   };

//   if (loading) {
//     return <Loader isLoading={loading} />;
//   }

//   return (
//     <Box>
//       <Tabs 
//         value={selectedTab} 
//         onChange={(_, newValue) => setSelectedTab(newValue)} 
//         variant="scrollable"
//       >
//         <Tab label="Patient List" />
//         {patientTabs.map((tab, index) => (
//           <Tab
//             key={tab.pid}
//             label={
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 {tab.name}
//                 <IconButton size="small" onClick={() => handleCloseTab(index)} sx={{ marginLeft: 1 }}>
//                   <CloseIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//             }
//           />
//         ))}
//       </Tabs>

//       <Box sx={{ marginTop: 2 }}>
//         {selectedTab === 0 ? (
//           <PatientList patients={patients.data} onPatientSelect={handleOpenTab} onDeleteSuccess={fetchData()}/>
//         ) : (
//           <PatientDetails {...patientTabs[selectedTab - 1]} />
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default PatientTabs;



// import React, { useEffect, useState } from "react";
// import { Tabs, Tab, Box, IconButton } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import { useApiContext } from "../../../Utils/ApiContext/ApiContext";
// import { useNavigate } from "react-router-dom";
// import Loader from "../../../Container/Loader/Loader";
// import PatientList from "./PatientList";
// import CryptoJS from "crypto-js";
// import PatientDetailsSidebar from "../PatientDetailsSidebar/PatientDetailsSidebar";

// const STORAGE_KEY = "patientTabsData";
// const SECRET_KEY = process.env.REACT_APP_USER_ENC_DEC_KEY; 

// const PatientTabs = () => {
//   const { patients, loading, fetchData } = useApiContext();
//   const navigate = useNavigate();
//   const [patientTabs, setPatientTabs] = useState([]);
//   const [selectedTab, setSelectedTab] = useState(1);

//   useEffect(() => {
//     fetchData('/apis/default/api/patient');
//   }, []);

//   const encryptData = (data) => {
//     return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
//   };

//   const decryptData = (encryptedData) => {
//     try {
//       const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
//       return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
//     } catch (error) {
//       console.error("Error decrypting data:", error);
//       return null;
//     }
//   };

//   useEffect(() => {
//     const storedData = sessionStorage.getItem(STORAGE_KEY);
//     if (storedData) {
//       const decryptedData = decryptData(storedData);
//       if (decryptedData && decryptedData.tabs.length > 0) {
//         setPatientTabs(decryptedData.tabs);
//         setSelectedTab(decryptedData.lastTab >= 0 ? decryptedData.lastTab : 0);
//       }
//     }
//     fetchData();
//   }, []);

//   useEffect(() => {
//     const encryptedTabs = encryptData({ tabs: patientTabs, lastTab: selectedTab });
//     sessionStorage.setItem(STORAGE_KEY, encryptedTabs);
//   }, [patientTabs, selectedTab]);


//   const handleOpenTab = (patient) => {
//     const existingIndex = patientTabs.findIndex((tab) => tab.pid === patient.pid);
//     if (existingIndex === -1) {
//       const newTab = {
//         pid: patient.pid,
//         uuid: patient.uuid,
//         name: `${patient.fname} ${patient.lname}`,
//         email: patient.email,
//         wallet_id: patient.wallet_id,
//         tabId: patientTabs.length + 2,
//       };
//       const updatedTabs = [...patientTabs, newTab];
//       setPatientTabs(updatedTabs);
//       setSelectedTab(updatedTabs.length + 1);
//       setTimeout(() => {
//         navigate(`/provider/patient/PatientDetails/${patient.uuid}/${patient.pid}`);
//       }, 100);
//     } else {
//       setSelectedTab(existingIndex + 2); // Fix: Directly switch to the existing tab
//       navigate(`/provider/patient/PatientDetails/${patientTabs[existingIndex].uuid}/${patientTabs[existingIndex].pid}`);
//     }
//   };
  

//   const handleCloseTab = (index) => {
//     const updatedTabs = patientTabs.filter((_, i) => i !== index);
//     setPatientTabs(updatedTabs);
  
//     if (updatedTabs.length === 0) {
//       setSelectedTab(1);
//       navigate("/provider/patient-list");
//     } else {
//       setSelectedTab(Math.max(1, selectedTab - 1));
//     }
//   };
  

//   const handleTabChange = (_, newValue) => {
//     setSelectedTab(newValue);
//     if (newValue === 0) {
//       navigate("/provider/dashboard");
//     } else if (newValue === 1) {
//       navigate("/provider/patient-list");
//     } else {
//       const selectedPatient = patientTabs[newValue - 2]; // Adjust index
//     if (selectedPatient) {
//       navigate(`/provider/patient/PatientDetails/${selectedPatient.uuid}/${selectedPatient.pid}`);
//     }
//       // navigate("/provider/patient/PatientDetails"); 
//     }
//   };
  

//   if (loading) {
//     return <Loader isLoading={loading} />;
//   }

//   return (
//     <Box>
//       <Tabs value={selectedTab} onChange={handleTabChange} variant="scrollable">
//         <Tab label="Home" />
//         <Tab label="Patient List" />
//         {patientTabs.map((tab, index) => (
//           <Tab
//             key={tab.pid}
//             label={
//               <Box sx={{ display: "flex", alignItems: "center" }}>
//                 {tab.name}
//                 <IconButton
//                   size="small"
//                   onClick={() => handleCloseTab(index)}
//                   sx={{ marginLeft: 1 }}
//                 >
//                   <CloseIcon fontSize="small" />
//                 </IconButton>
//               </Box>
//             }
//           />
//         ))}
//       </Tabs>

//       <Box sx={{ marginTop: 2 }}>
//         {selectedTab === 1 ? (
//           <PatientList
//             patients={patients.data}
//             onPatientSelect={handleOpenTab}
//             onDeleteSuccess={fetchData}
//           />
//         ) : selectedTab > 1 ? (
//           <PatientDetailsSidebar {...patientTabs[selectedTab - 2]} />
//         ) : null}
//       </Box>
//     </Box>
//   );
// };

// export default PatientTabs;


import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box, IconButton } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import PeopleIcon from "@mui/icons-material/People";
import CloseIcon from "@mui/icons-material/Close";
import { useApiContext } from "../../../Utils/ApiContext/ApiContext";
import { useNavigate } from "react-router-dom";
import Loader from "../../../Container/Loader/Loader";
import PatientList from "./PatientList";
import CryptoJS from "crypto-js";
import PatientDetailsSidebar from "../PatientDetailsSidebar/PatientDetailsSidebar";

const STORAGE_KEY = "patientTabsData";
const SECRET_KEY = process.env.REACT_APP_USER_ENC_DEC_KEY;

const PatientTabs = () => {
  const { patients, loading, fetchData } = useApiContext();
  const navigate = useNavigate();
  const [patientTabs, setPatientTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);

  useEffect(() => {
    fetchData('/apis/default/api/patient');
  }, []);

  const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  };

  const decryptData = (encryptedData) => {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
      console.error("Error decrypting data:", error);
      return null;
    }
  };

  useEffect(() => {
    const storedData = sessionStorage.getItem(STORAGE_KEY);
    if (storedData) {
      const decryptedData = decryptData(storedData);
      if (decryptedData && decryptedData.tabs.length > 0) {
        setPatientTabs(decryptedData.tabs);
        setSelectedTab(decryptedData.lastTab >= 0 ? decryptedData.lastTab : 0);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    const encryptedTabs = encryptData({ tabs: patientTabs, lastTab: selectedTab });
    sessionStorage.setItem(STORAGE_KEY, encryptedTabs);
  }, [patientTabs, selectedTab]);

  const handleOpenTab = (patient) => {
    const existingIndex = patientTabs.findIndex((tab) => tab.pid === patient.pid);
    if (existingIndex === -1) {
      const newTab = {
        pid: patient.pid,
        uuid: patient.uuid,
        name: `${patient.fname} ${patient.lname}`,
        email: patient.email,
        wallet_id: patient.wallet_id,
        tabId: patientTabs.length + 2,
      };
      const updatedTabs = [...patientTabs, newTab];
      setPatientTabs(updatedTabs);
      setSelectedTab(updatedTabs.length + 1);
      setTimeout(() => {
        navigate(`/provider/patient/PatientDetails/${patient.uuid}/${patient.pid}`);
      }, 100);
    } else {
      setSelectedTab(existingIndex + 2);
      navigate(`/provider/patient/PatientDetails/${patientTabs[existingIndex].uuid}/${patientTabs[existingIndex].pid}`);
    }
  };

  const handleCloseTab = (index) => {
    const updatedTabs = patientTabs.filter((_, i) => i !== index);
    setPatientTabs(updatedTabs);

    if (updatedTabs.length === 0) {
      setSelectedTab(1);
      navigate("/provider/patient-list");
    } else {
      setSelectedTab(Math.max(1, selectedTab - 1));
    }
  };

  const handleTabChange = (_, newValue) => {
    setSelectedTab(newValue);
    if (newValue === 0) {
      navigate("/provider/dashboard");
      setSelectedTab(1);
    } else if (newValue === 1) {
      navigate("/provider/patient-list");
    } else {
      const selectedPatient = patientTabs[newValue - 2];
      if (selectedPatient) {
        navigate(`/provider/patient/PatientDetails/${selectedPatient.uuid}/${selectedPatient.pid}`);
      }
    }
  };

  if (loading) {
    return <Loader isLoading={loading} />;
  }

  return (
    <Box>
      <Tabs value={selectedTab} onChange={handleTabChange} variant="scrollable">
        <Tab
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <HomeIcon fontSize="small" />
              Home
            </Box>
          }
        />
        <Tab
          label={
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <PeopleIcon fontSize="small" />
              Patient List
            </Box>
          }
        />
        {patientTabs.map((tab, index) => (
          <Tab
            key={tab.pid}
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {tab.name}
                <IconButton
                  size="small"
                  onClick={() => handleCloseTab(index)}
                  sx={{ marginLeft: 1 }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
            }
          />
        ))}
      </Tabs>

      <Box sx={{ marginTop: 2 }}>
        {selectedTab === 1 ? (
          <PatientList
            patients={patients.data}
            onPatientSelect={handleOpenTab}
            onDeleteSuccess={fetchData}
          />
        ) : selectedTab > 1 ? (
          <PatientDetailsSidebar {...patientTabs[selectedTab - 2]} />
        ) : null}
      </Box>
    </Box>
  );
};

export default PatientTabs;
